module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/baby-sitting/child-age1-3638fda40925c52b7cc6051943d6c8f9.svg";